import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import api from "../../../services/axiosConfig";
import { useState } from "react";
import ServiceLimitBottomSheet from "../../ServiceLimitBottomSheet/ServiceLimitBottomSheet";



const CardHorizontal = ({ car }) => {

  const navigate = useNavigate();

  const [

    showLimit,

    setShowLimit,

] = useState(false);

  const getServiceCount = async (carId) => {

    const { data } = await api.get(

        `/api/Operate/GetServiceCount/${carId}`

    );

    return data;

  };

  const clickHandler = async () => {

    const result = await getServiceCount(car.id);

    if (result >= 30) {

      setShowLimit(true);
      return;

    }

    navigate(
        `/add-service-step-2/${car.id}/${car.title}`
    );

  };

  // const clickHandler = () => {

  //   const result = getServiceCount(car.id);

  //   navigate(`/add-service-step-2/${car.id}/${car.title}`);
  // };

  return (
    <>
      <motion.div
        className="card shadow-sm border-0 rounded-3 p-3 h-100 d-flex align-items-center flex-row"
        onClick={clickHandler}
        role="button"
        whileHover={{ scale: 1.03, boxShadow: "0px 6px 20px rgba(0,0,0,0.15)" }}
        transition={{ type: "spring", stiffness: 200, damping: 12 }}
      >
        {/* تصویر دایره‌ای */}
        <img
          src={car.imageUrl}
          alt={car.title}
          className="rounded-circle me-3"
          style={{
            width: "80px",
            height: "80px",
            objectFit: "cover",
            border: "2px solid #eee",
          }}
        />

        {/* اطلاعات خودرو */}
        <div className="flex-grow-1">
          <h6 className="fw-bold mb-1">{car.title}</h6>
          <p className="mb-0 text-secondary small">
            سال ساخت: {car.productYear}
          </p>
          <p className="mb-0 text-muted small">کیلومتر: {car.kilometer}</p>
        </div>
      </motion.div>

      <ServiceLimitBottomSheet

        open={showLimit}

        carTitle={car.title}

        onClose={()=>setShowLimit(false)}

      />
    </>
  );
};

export default CardHorizontal;
